<template>
  <div class="container">
    <div class="header-image-wrapper">
      <h1>Stay On Track</h1>
    </div>

    <v-row>
      <v-col cols="12">
        <div class="how-it-works-item">
          <v-row>
            <v-col cols="12" md="1" class="num num-1 text-center">
              1.
            </v-col>
            <v-col cols="12" md="5" class="num-1">
              <h3>
                State Objectives
              </h3>
              <ul>
                <li>
                  You work with our product team to define your next objectives.
                </li>

                <li>
                  The team will quote each feature and you choose what features
                  to move forward on.
                </li>
              </ul>
            </v-col>
            <v-col cols="12" md="6" class="pa-2">
              <p>
                <v-img src="/img/dev-steps/add-objective.jpg"> </v-img>
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="how-it-works-item">
          <v-row>
            <v-col cols="12" md="1" class="num num-2 text-center">
              2.
            </v-col>
            <v-col cols="12" md="5" class="num-2">
              <h3>
                Define Success
              </h3>
              <ul>
                <li>
                  Add key results to comunicate how you will mesure each
                  objective.
                </li>
              </ul>
            </v-col>
            <v-col cols="12" md="6" class="pa-2">
              <p>
                <v-img src="/img/dev-steps/add-kr.jpg"> </v-img>
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="how-it-works-item">
          <v-row>
            <v-col cols="12" md="1" class="num num-3 text-center">
              3.
            </v-col>
            <v-col cols="12" md="5" class="num-3">
              <h3>
                Mesure
              </h3>
              <ul>
                <li>
                  You and the team score each item to mesure how well the
                  objective was meet.
                </li>
              </ul>
            </v-col>
            <v-col cols="12" md="6" class="pa-2">
              <p>
                <v-img src="/img/dev-steps/score-kr.jpg"> </v-img>
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<style lang="scss" scoped>
.header-image-wrapper {
  //   background-image: url("/img/tools-bg.jpg");
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(/img/tools-bg.jpg) no-repeat center center;
  height: 400px;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-size: 5.5rem;
    // margin: 55px auto;
    padding-top: 130px;
  }
}
.num {
  font-size: 3rem;
}
.num-1 {
  padding-top: 15px;
}
.num-2 {
  padding-top: 100px;
}
.num-3 {
  padding-top: 200px;
}
</style>
<script>
export default {};
</script>
